import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCreatePostMutation } from '@/apis/posts';
import { Pathes } from '@/constants';
import { useToastMessageRequest } from '@/hooks';

export const useCreatePostPage = () => {
  const [createPost, { isLoading, isSuccess, ...requestParams }] =
    useCreatePostMutation();

  useToastMessageRequest({ isSuccess, ...requestParams });

  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess) {
      navigate(Pathes.Posts);
    }
  }, [isSuccess]);

  const onSubmit = useCallback((params: any) => {
    createPost(params);
  }, []);

  return { isLoading, onSubmit };
};
